import { render } from "./Default.vue?vue&type=template&id=349e23dd&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"

import "./Default.vue?vue&type=style&index=0&id=349e23dd&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349e23dd"]])

export default __exports__